"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
var Scroll = function () {
    var links = document.querySelectorAll(".scroller");
    var nav = document.querySelector(".nav__bg");
    if (links.length === 0)
        return;
    links.forEach(function (link) {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            var target = e.target;
            var href = target.getAttribute("href");
            var hash = target.hash;
            if (href === hash) {
                var el = document.querySelector(hash);
                if (!el)
                    return;
                window.scrollTo({
                    top: el.offsetTop - nav.offsetHeight,
                    behavior: "smooth",
                });
            }
            else {
                window.location.href = href;
            }
        });
    });
};
exports.Scroll = Scroll;
